// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"168":"95557a8b21a6b921","187":"db478dbb677efac1"}[chunkId] + ".js";
};